import React from 'react'

export function InterstitialButtonText({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <span>{children}</span>
}
